import { initFavorites } from './utils/favorites.js';

initFavorites();

